import React from 'react';

export const Ai_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>SERVICIOS DE AI</span>,
  },
];

export const First_Title = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '500',
    renderContent: () => <span>PREVISUALIZACIÓN ILIMITADA (PRE-VIZ)</span>,
  },
];

export const First_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '400',
    renderContent: () => (
      <span>
        Convertimos guiones y moodboards en animatics y storyboards casi finales
        usando AI. Iteramos en tiempo real hasta cerrar el diseño de producción
        correcto antes de pisar set.
      </span>
    ),
  },
];

export const Second_Title = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '500',
    renderContent: () => <span>MODELADO DE PERSONAJES (CASTING)</span>,
  },
];

export const Second_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '400',
    renderContent: () => (
      <span>
        Generamos avatares preliminares con los rasgos de cada personaje.
        Llegamos al casting con el look definido y un perfil visual claro para
        cada rol.
      </span>
    ),
  },
];

export const Third_Title = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '500',
    renderContent: () => <span>IDEACIÓN Y PROTOTIPADO RÁPIDO</span>,
  },
];

export const Third_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '400',
    renderContent: () => (
      <span>
        Armamos mock-ups de campañas completas (frames clave, animatics, piezas
        para redes) en cuestión de horas. Ideal para pruebas de concepto,
        pitches y presentaciones con cliente sin montar una producción completa.
      </span>
    ),
  },
];

export const Fourth_Title = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '500',
    renderContent: () => <span>CONTENIDO ON-DEMAND Y ADAPTACIÓN</span>,
  },
];

export const Fourth_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '400',
    renderContent: () => (
      <span>
        Generamos múltiples variaciones de una misma pieza para distintas
        audiencias, formatos y plataformas sin regrabar. Ajustamos mensaje,
        encuadre y duración manteniendo la misma línea creativa y de marca.
      </span>
    ),
  },
];

export const Fifth_Title = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '500',
    renderContent: () => <span>WORLD-BUILDING & DISEÑO DE ARTE</span>,
  },
];

export const Fifth_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '400',
    renderContent: () => (
      <span>
        Diseñamos mundos, vestuarios y props completos en AI para asegurar
        coherencia visual. Reducimos carga de VFX costosos resolviendo
        decisiones clave desde arte.
      </span>
    ),
  },
];

export const Sixth_Title = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '500',
    renderContent: () => <span>ANÁLISIS PREDICTIVO DE GUION</span>,
  },
];

export const Sixth_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '400',
    renderContent: () => (
      <span>
        Analizamos el guion con AI para detectar planos complejos y riesgos
        logísticos. Optimizamos calendario, recursos y costos antes del rodaje.
      </span>
    ),
  },
];

export const Seventh_Title = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '500',
    renderContent: () => <span>EJECUCIÓN DE ALTA FIDELIDAD</span>,
  },
];

export const Seventh_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '400',
    renderContent: () => (
      <span>
        Conectamos tu proyecto con los perfiles de AI filmmaking adecuados y
        nuestro equipo de producción para llevarlo a look cinematográfico.
        Entregamos piezas listas para marca, campaña y distribución.
      </span>
    ),
  },
];

export const Artist_Title = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '500',
    renderContent: () => <span>AI ARTISTS</span>,
  },
];

export const Artist_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    fontWeight: '400',
    renderContent: () => <span>Creado por humanos, potenciado por AI</span>,
  },
];
